import {
  Home,
  Users,
  UserPlus,
  PackageCheck,
  Clock,
  Lightbulb,
  Coins,
  Layers,
  IdCard,
  Plug,
  Megaphone,
  Monitor,
  TrendingUp,
  Calculator,
  LayoutDashboard,
  Bitcoin,
  Wifi,
  History,
  Activity,
  ReplyAll,
  Link,
  Headset,
  Wallet,
  GraduationCap,
  FlaskConical,
  HelpCircle,
  Settings,
  TableProperties,
  UserCog,
  KeyRound,
  Briefcase,
  RadioTower,
  Users2,
  Code,
  Puzzle,
  Component,
  BarChart4,
  RotateCcw,
  Sigma,
  Bug
} from "lucide-react";


export const admin_sidebar = [
  {
    id: 0,
    name: "Dashboard",
    Icon: Home,
    route: "/admin/dashboard",
    Data: [],
  },
  {
    id: 1,
    name: "Clients",
    Icon: Users,
    route: "/admin/allclients",
    Data: [],
  },
  {
    id: 2,
    Icon: UserPlus,
    name: "Sub Admins",
    route: "/admin/allsubadmins",
  },
  // { ... }
  {
    id: 4,
    name: "All Orders",
    route: "/admin/orders",
    Icon: PackageCheck,
  },
  // { ... }
  {
    id: 6,
    name: "Trade History",
    route: "/admin/tradehistory",
    Icon: Clock,
  },
  {
    id: 7,
    name: "Strategies",
    route: "/admin/strategies",
    Icon: Lightbulb,
    Data: [],
  },
  {
    id: 8,
    name: "All Stocks",
    route: "/admin/allservices",
    Icon: Coins,
  },
  {
    id: 9,
    name: "Stock Group Services",
    route: "/admin/groupservices",
    Icon: Layers,
  },
  {
    id: 10,
    name: "Active Services",
    route: "/admin/allLicence",
    Icon: IdCard,
  },
  {
    id: 11,
    name: "Connect Your Broker",
    route: "/admin/apicreateinfo",
    Icon: Plug,
  },
  // { ... }
  {
    id: 13,
    name: "Message Broadcast",
    route: "/admin/msgbroadcast",
    Icon: Megaphone,
  },
  {
    id: 14,
    name: "Trade Monitoring",
    route: "/admin/trademonitoring",
    Icon: Monitor,
  },
  {
    id: 15,
    name: "Trade",
    route: "/admin/trade",
    Icon: TrendingUp,
  },
  // { ... }
  {
    id: 16,
    name: "trade Calculation",
    route: "/admin/tradecalculation",
    Icon: Calculator,
  },
  {
    id: 17,
    name: "Report Bug",
    route: "/admin/bug",
    Icon: Bug,
  }
];


export const Client = [
  {
    id: 0,
    name: "Dashboard",
    Icon: LayoutDashboard,
    route: "/client/dashboard",
    Data: [],
  },
  {
    id: 1,
    // name: "Stocks",
    name: "Crypto",
    Icon: Bitcoin,
    route: "/client/stocks",
    Data: [],
  },
  {
    id: 2,
    name: "Signals",
    Icon: Wifi,
    route: "/client/signals",
    Data: [],
  },
  {
    id: 3,
    name: "Trade History",
    Icon: History,
    route: "/client/tradehistory",
    Data: [],
  },
  {
    id: 4,
    name: "Trading Status",
    Icon: Activity,
    route: "/client/tradingstatus",
    Data: [],
  },
  {
    id: 5,
    name: "Broker Response",
    Icon: ReplyAll,
    route: "/client/brokerresponse",
    Data: [],
  },
  {
    id: 6,
    name: "Connect Your Broker",
    Icon: Link,
    route: "/client/apicreateinfo",
    Data: [],
  },
  {
    id: 7,
    name: "Help Center",
    Icon: Headset,
    route: "/client/helpcenter",
    Data: [],
  },
  {
    id: 8,
    name: "Wallet",
    Icon: Wallet,
    route: "/client/wallet",
    Data: [],
  },
  {
    id: 9,
    name: "Tutorials & Guides",
    Icon: GraduationCap,
    route: "/client/tutorials",
    Data: [],
  },
  {
    id: 10,
    name: "Backtesting",
    Icon: FlaskConical,
    route: "/client/backtesting",
    Data: [],
  },
  {
    id: 11,
    name: "FAQ",
    Icon: HelpCircle,
    route: "/client/faq",
    Data: [],
  },
  {
    id: 12,
    name: "Calculation",
    Icon: Settings,
    route: "/client/calculation",
    Data: [],
  },
  {
    id: 13,
    name: "Report Bug",
    Icon: Bug,
    route: "/client/bug",
    Data: [],
  }
];


export const supper_admin_sidebar = [
  {
    id: 0,
    name: "Dashboard",
    Icon: TableProperties,
    route: "/super/dashboard",
    Data: [],
  },
  {
    id: 1,
    name: "All Admins",
    Icon: UserCog,
    route: "/super/alladmins",
    Data: [],
  },
  {
    id: 2,
    name: "All Permissions",
    Icon: KeyRound,
    route: "/super/permitions",
    Data: [],
  },
  {
    id: 3,
    name: "History",
    Icon: Clock,
    route: "/super/history",
    Data: [],
  },
  {
    id: 4,
    name: "Faq",
    Icon: HelpCircle,
    route: "/super/update/faq",
    Data: [],
  },
  {
    id: 5,
    name: "Broker Details",
    Icon: Briefcase,
    route: "/super/brokerdetails",
    Data: [],
  },
];

export const sub_admin_sidebar = [
  {
    id: 0,
    name: "Dashboard",
    Icon: Home,
    route: "/subadmin/dashboard",
    Data: [],
  },
  {
    id: 1,
    name: "Signals",
    Icon: RadioTower,
    route: "/subadmin/signals",
    Data: [],
    sidebar: "Signals"
  },
  {
    id: 2,
    name: "All Clients",
    Icon: Users2,
    route: "/subadmin/clients",
    Data: [],
  },
  {
    id: 4,
    name: "Api Create Info",
    Icon: Code,
    route: "/subadmin/apicreateinfo",
    Data: [],
  },
  {
    id: 5,
    name: "Strategies",
    route: "/subadmin/chess-knight",
    Icon: Puzzle,
    Data: [],
  },
  {
    id: 6,
    name: "Stock Group Services",
    route: "/subadmin/groupservices",
    Icon: Component,
  },
  {
    id: 7,
    name: "Trade",
    route: "/subadmin/trade",
    Icon: BarChart4,
  },
  {
    id: 9,
    name: "Trade History",
    Icon: RotateCcw,
    route: "/subadmin/TradeHistory",
    Data: [],
  },
  {
    id: 10,
    name: "Trade Calculation",
    Icon: Sigma,
    route: "/subadmin/tradeCcalculation",
    Data: [],
  },
  {
    id: 11,
    name: "Report Bug",
    Icon: Bug,
    route: "/subadmin/bug",
    Data: [],
  }
];